// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class SelectTreeService {
  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public getEntitySelectWhere<T>(params): Observable<T> {
    const url = this.Global.api.entity.select.where();
    return this.sendService.get(url, { params });
  }

  public auxEntity<T>(params, filter): Observable<T> {
    if (Object.keys(filter).length > 0) {
      params.filters = JSON.stringify(filter);
    }
    const { entityUrl: url } = params;

    if (params.entityUrl) delete params.entityUrl;
    return this.sendService.get(url, { params });
  }

  public getData<T>(url, { params }): Observable<T> {
    return this.sendService.get(url, { params });
  }

  public breadcrumbEntity<T>(data, id, flowId?): Observable<T> {
    const url = data.entityUrl;
    const params: any = { id, tableName: data.tableName, flowId: flowId };
    if (data.context) {
      params.context = data.context;
    }
    if (!data.tableName) delete params.tableName;
    if (!id) return new Observable(); //Temp: evitando retorno de id não encontrado
    return this.sendService.get(url, { params });
  }
}
